<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html, body {
  height: 100%;
}
body {
  margin: 0;
}

#app {
  /* font-family: 'Lato', Helvetica, Arial, sans-serif; */
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  text-align: center;
  height: 100%;
}

/* recommended css code for vue-svgicon */
.svg-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    color: inherit;
    vertical-align: middle;
    fill: none;
    stroke: currentColor;
}

/* SVG ICONS */
.svg-fill {
  fill: currentColor;
  stroke: none;
}
.svg-up {
  /*default*/
  transform: rotate(0deg);
}
.svg-right {
  transform: rotate(90deg);
}
.svg-down {
  transform: rotate(180deg);
}
.svg-left {
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// App.vue?6c8888fd